module.exports = __webpack_public_path__ + "img/202307_02.0e971200.jpg";